package ru.villawonka.app.presentation.model

import ru.villawonka.app.domain.model.AccommodationTypeDomain
import ru.villawonka.app.resources.AppResources

sealed class AccommodationTypeUIModel {

    val key: String = AppResources.strings.accommodationType

    abstract val value: String

    class Apartment : AccommodationTypeUIModel() {

        override val value: String = AppResources.strings.accommodationTypeAppartament
    }

    class Villa : AccommodationTypeUIModel() {

        override val value: String = AppResources.strings.accommodationTypeVilla
    }

    class Guesthouse : AccommodationTypeUIModel() {

        override val value: String = AppResources.strings.accommodationTypeGuesthouse
    }

    class Room : AccommodationTypeUIModel() {

        override val value: String = AppResources.strings.accommodationTypeRoom
    }
}

fun AccommodationTypeDomain.toUIModel(): AccommodationTypeUIModel = when (this) {
    AccommodationTypeDomain.APARTMENT -> AccommodationTypeUIModel.Apartment()
    AccommodationTypeDomain.GUESTHOUSE -> AccommodationTypeUIModel.Guesthouse()
    AccommodationTypeDomain.ROOM -> AccommodationTypeUIModel.Room()
    AccommodationTypeDomain.VILLA -> AccommodationTypeUIModel.Villa()
}